module.exports = ":host main {\n  position: relative; }\n"